import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface ResolveAmbiguousUserIdentityConflictParams {
    id: string;
    dataRecordId: string;
}

export class ResolveAmbiguousUserIdentityConflictRequest extends Request<ResolveAmbiguousUserIdentityConflictParams, IResult> {
  constructor(params: ResolveAmbiguousUserIdentityConflictParams) {
    super('resolveAmbiguousUserIdentityConflict', params);
  }
}
